var AbstractDialog = require("./AbstractDialog");
var Utils = require("common/Utils");

/**
 * Dialog to display error message to user
 *
 * @class
 */
var ErrorDialog = function() {
    AbstractDialog.call(this);

    var $message = $('<div class="errorText errorIcon">');

    var $content = this.getContent();
    $content.append($message);
    $content.attr("id", "errorDialog");

    var closeCallback;

    this.setTitle($.t("common::error.title"));

    this.setMessage = function(message, doNotEscape) {
        if (doNotEscape) {
            $message.html(message);
        } else {
            $message.text(message);
        }
    };

    this.setCloseCallback = function(callback) {
        closeCallback = callback;

        if (callback) {
            $content.one("popupafterclose", callback);
        }
    };
};

Utils.inherits(ErrorDialog, AbstractDialog);

module.exports = ErrorDialog;